var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{class:{
    'change-articles__column--side page-switch__column': true,
    'page-switch__column--hidden': _vm.hide
  }},[_c('div',{staticClass:"page-switch__wrapper"},[_c('app-button',{attrs:{"disabled":_vm.disabled,"icon":_vm.icon,"small":"","outlined":""},on:{"click":function($event){return _vm.$emit('click')}}}),_c('div',{staticClass:"pagination__next-product-code caption"},[_vm._t("default")],2)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }